/**
 * Display-only travel type label for the unclaimed commissions table and
 * filters. Delegates to the shared single source of truth for the Cruise/Tour
 * display overrides; only the empty-value placeholder is table-specific.
 */
import { travelTypeDisplayLabel } from '@shared/travel-type';

export function formatUnclaimedTravelTypeDisplay(
  travelType: string | null | undefined,
): string {
  const raw = travelType?.trim();
  if (!raw) return '—';
  return travelTypeDisplayLabel(raw);
}
